import Settings from "@/services/settings";

export async function loadChatwootScript(_userAmount: number, userType: string) {
  if (typeof window === "undefined") return () => {};
  if ((window as any).__chatwootLoaded) return () => {};

  Settings.loadSettings().then(async settings => {
    const data = settings;
    const unparsedJWT = localStorage.getItem("TOKEN_LOGIN");
    const jwt = JSON.parse(atob(unparsedJWT?.split(".")?.[1] ?? ""));
    const email = jwt.email;
    const userId = jwt.userId;

    if (!data || !userType || !email) {
      return;
    }

    // 2026-07-14: só professor NMG com plano tipo teacher no Stripe fica FORA do
    // Chatwoot — o suporte dele é exclusivamente o formulário HelpChatPanel, que
    // cai no e-mail do Breno (POST /support/contact). Escolas NMG (signupProfile
    // "school" / plano school_*) usam Chatwoot como as Legacy. Refina a regra de
    // 2026-07-13 (pedido do Breno, Operações, mensagem 80150067018154), que
    // bloqueava NMG inteiro. Mesmo critério do gate do botão "Ajuda" na sidebar
    // (isTeacherPlanNmgSupport em v0/novo/sidebar.tsx) — manter os dois em sincronia.
    const account = data?.accountsDetails?.[0];
    const isNewManagerGlobal = Boolean(account?.["new-manager-global"]);
    const isSchoolPlanAccount =
      account?.signupProfile === "school" ||
      String(account?.signupPlanKey ?? "").startsWith("school_");
    if (isNewManagerGlobal && !isSchoolPlanAccount) {
      return;
    }

    (window as any).__chatwootLoaded = true;

    const settingsScript = document.createElement("script");
    settingsScript.text = `
      window.chatwootSettings = {
        position: "right",
        type: "standard"
      };
    `;
    document.body.appendChild(settingsScript);

    window.addEventListener("chatwoot:ready", function () {
      const chatwoot = (window as any).$chatwoot;
      if (!chatwoot) return;

      if (userId) {
        chatwoot.setUser(userId, {
          name: data.username,
          email: email,
        });
      }

      chatwoot.setCustomAttributes({
        company_id: data.schoolName,
        school_name: data.schoolName,
        tag_user: userType,
      });
    });

    const loaderScript = document.createElement("script");
    loaderScript.text = `
      (function(d, t) {
        var BASE_URL = "https://app.chatwoot.com";
        var g = d.createElement(t), s = d.getElementsByTagName(t)[0];
        g.src = BASE_URL + "/packs/js/sdk.js";
        g.async = true;
        s.parentNode.insertBefore(g, s);
        g.onload = function() {
          window.chatwootSDK.run({
            websiteToken: 'QjP3mEvhyposHCy1fbQbxHej',
            baseUrl: BASE_URL
          });
        };
      })(document, "script");
    `;
    document.body.appendChild(loaderScript);
  });

  return () => {};
}
